module.exports = __webpack_public_path__ + "static/media/CNX-CNX-20.5dbf7560.jpg";